// extracted by mini-css-extract-plugin
export default {"emptyStateDivBox":"emptyStateDivBox__QTjwZ","tuyaListBody":"tuyaListBody__h7F0c"};